(function () {
  // document.body.classList.add("test1");

  // Desktop Event Listeners
  document.querySelector(".vb-size").addEventListener("click", () => {
    // console.log("vb-size");

    document.body.classList.remove("vb-filter");
    if (document.body.classList.contains("vb-sort")) {
      document.querySelector(".filters-desktop .dropdown-button").click();
      document.body.classList.remove("vb-sort");
    }

    if (document.body.classList.contains("vb-size")) {
      document.querySelector(".filters-desktop .dropdown-button").click();
      setTimeout(() => {
        document.body.classList.remove("vb-size");
      }, 200);
    } else {
      document.body.classList.add("vb-size");
      if (
        !document.querySelector(".filters-desktop").classList.contains("active")
      ) {
        document.querySelector(".filters-desktop .dropdown-button").click();
      }
    }
  });

  document.querySelector(".vb-sort").addEventListener("click", () => {
    // console.log("vb-sort");

    document.body.classList.remove("vb-filter");
    if (document.body.classList.contains("vb-size")) {
      document.querySelector(".filters-desktop .dropdown-button").click();
      document.body.classList.remove("vb-size");
    }

    if (document.body.classList.contains("vb-sort")) {
      document.querySelector(".filters-desktop .dropdown-button").click();
      setTimeout(() => {
        document.body.classList.remove("vb-sort");
      }, 200);
    } else {
      document.body.classList.add("vb-sort");
      if (
        !document.querySelector(".filters-desktop").classList.contains("active")
      ) {
        document.querySelector(".filters-desktop .dropdown-button").click();
      }
    }
  });

  document.querySelector(".vb-filter").addEventListener("click", () => {
    // console.log("vb-filter");
    if (
      document.body.classList.contains("vb-size") ||
      document.body.classList.contains("vb-sort")
    ) {
      document.querySelector(".filters-desktop .dropdown-button").click();
      document.body.classList.remove("vb-size");
      document.body.classList.remove("vb-sort");
    }

    if (document.body.classList.contains("vb-filter")) {
      document.querySelector(".filters-desktop .dropdown-button").click();
    } else {
      document.body.classList.add("vb-filter");
      if (
        !document.querySelector(".filters-desktop").classList.contains("active")
      ) {
        document.querySelector(".filters-desktop .dropdown-button").click();
      }
    }
  });

  // Mobile Event Listeners
  if (
    document.querySelector(".items-per-row-x1").classList.contains("opacity-50")
  ) {
    document.querySelector(".vb-items-per-row.x1").classList.add("opacity-50");
  } else {
    document.querySelector(".vb-items-per-row.x2").classList.add("opacity-50");
  }

  document.querySelectorAll(".vb-items-per-row").forEach((vbItemsPerRow) => {
    vbItemsPerRow.addEventListener("click", (e) => {
      document.querySelectorAll(".vb-items-per-row").forEach((vbIPR) => {
        vbIPR.classList.add("opacity-50");
      });
      e.target.classList.remove("opacity-50");

      let x = e.target.innerText.indexOf("1x") > -1 ? "x1" : "x2";
      document.querySelector(".items-per-row-" + x).click();
    });
  });

  document.querySelector(".vb-sort-mobile").addEventListener("click", () => {
    document.body.classList.remove("vb-size-mobile");
    document.body.classList.remove("vb-filter-mobile");

    if (!document.body.classList.contains("vb-sort-mobile")) {
      document.body.classList.add("vb-sort-mobile");
      // open sort filter options
      if (
        document.querySelector(
          ".filter-row-mobile-sort-by .dropdown-button:not(.active)"
        )
      ) {
        document
          .querySelector(".filter-row-mobile-sort-by .dropdown-button")
          .click();
      }
      // open main filter
      if (
        !document.querySelector(".filters-mobile").classList.contains("active")
      ) {
        setTimeout(() => {
          document.querySelector(".filters-mobile .filter-sort").click();
        }, 200);
      }
    } else {
      // close main filter
      document.querySelector(".filters-mobile .filter-sort").click();
      document.body.classList.remove("vb-sort-mobile");
    }
  });

  document.querySelector(".vb-filter-mobile").addEventListener("click", () => {
    document.body.classList.add("vb-filter-mobile");
    if (
      !document.querySelector(".filters-mobile").classList.contains("active")
    ) {
      // open main filter
      document.querySelector(".filters-mobile .filter-sort").click();
    } else {
      if (
        document.body.classList.contains("vb-size-mobile") ||
        document.body.classList.contains("vb-sort-mobile")
      ) {
        document.body.classList.remove("vb-size-mobile");
        document.body.classList.remove("vb-sort-mobile");
        if (
          document.querySelector(".filters-mobile").classList.contains("active")
        ) {
          // close main filter
          document.querySelector(".filters-mobile .filter-sort").click();
          // open main filter
          document.querySelector(".filters-mobile .filter-sort").click();
        }
      } else {
        document.querySelector(".filters-mobile .filter-sort").click();
        document.body.classList.remove("vb-filter-mobile");
      }
    }
  });

  document.querySelector(".vb-size-mobile").addEventListener("click", () => {
    document.body.classList.remove("vb-sort-mobile");
    document.body.classList.remove("vb-filter-mobile");

    if (!document.body.classList.contains("vb-size-mobile")) {
      document.body.classList.add("vb-size-mobile");
      // open sort filter options
      if (
        document.querySelector(
          ".filter-row-mobile-size-apparel .dropdown-button:not(.active)"
        )
      ) {
        document
          .querySelector(".filter-row-mobile-size-apparel .dropdown-button")
          .click();
      }

      // open main filter
      if (
        !document.querySelector(".filters-mobile").classList.contains("active")
      ) {
        setTimeout(() => {
          document.querySelector(".filters-mobile .filter-sort").click();
        }, 200);
      }
    } else {
      // close main filter
      document.querySelector(".filters-mobile .filter-sort").click();
      document.body.classList.remove("vb-size-mobile");
    }
  });

  window.addEventListener("scroll", function () {
    if (document.body.classList.contains("test1")) {
      const stickyElement = document.querySelector("nav.filters-mobile");
      const stickyOffset = stickyElement.offsetTop;

      if (window.scrollY >= stickyOffset) {
        stickyElement.classList.add("vb-sticky");
      } else {
        stickyElement.classList.remove("vb-sticky");
      }
    }
  });

  // adjust order for size 0 && 00
  // desktop
  let au46D = document.querySelector(
    'body.test1 .filters-desktop li> input[name="filter.v.option.size"][value="00"]'
  );
  let au68D = document.querySelector(
    'body.test1 .filters-desktop li >input[name="filter.v.option.size"][value="0"]'
  );
  if (au46D && au68D) {
    let au46Dli = au46D.parentElement;
    let au68Dli = au68D.parentElement;
    au68Dli.insertAdjacentElement("beforebegin", au46Dli);
  }

  // mobile
  let au46M = document.querySelector(
    'body.test1 .filters-mobile li> input[name="filter.v.option.size"][value="00"]'
  );
  let au68M = document.querySelector(
    'body.test1 .filters-mobile li >input[name="filter.v.option.size"][value="0"]'
  );
  if (au46M && au68M) {
    let au46Mli = au46M.parentElement;
    let au68Mli = au68M.parentElement;
    au68Mli.insertAdjacentElement("beforebegin", au46Mli);
  }

  // size + stock
  // desktop
  let sizeInputSelector =
    '.filters-desktop ol.filter-row-size-apparel input[name="filter.v.option.size"]';
  let sizeCheckedInputSelector = sizeInputSelector + ":checked";
  let inStockInputSelector =
    '.filters-desktop form[data-filter-form] input[name="filter.v.availability"][value="1"]';

  let inStockInput = document.querySelector(inStockInputSelector);
  document.querySelectorAll(sizeInputSelector).forEach((input) => {
    input.addEventListener("change", () => {
      if (
        input.checked &&
        !inStockInput.checked &&
        document.querySelectorAll(sizeCheckedInputSelector).length
      ) {
        inStockInput.click();
      }
    });
  });

  // mobile
  let sizeInputSelectorMobile =
    '.filters-mobile div.filter-row-mobile-size-apparel input[name="filter.v.option.size"]';
  let sizeCheckedInputSelectorMobile = sizeInputSelectorMobile + ":checked";
  let inStockInputSelectorMobile =
    '.filters-mobile form[data-filter-form] input[name="filter.v.availability"][value="1"]';
  let inStockInputMobile = document.querySelector(inStockInputSelectorMobile);

  document.querySelectorAll(sizeInputSelectorMobile).forEach((input) => {
    input.addEventListener("change", () => {
      if (
        input.checked &&
        !inStockInputMobile.checked &&
        document.querySelectorAll(sizeCheckedInputSelectorMobile).length
      ) {
        inStockInputMobile.click();
      }
    });
  });
})();
